import React, { useState, useEffect } from 'react';
import './Header.css';
import LoginModal from './LoginModal';
import { Link, useNavigate } from 'react-router-dom';

const Header = () => {
  const [usuario, setUsuario] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUsuario = localStorage.getItem('usuario');

    if (token && storedUsuario) {
      setUsuario(JSON.parse(storedUsuario));
    }
  }, []);

  const cerrarSesion = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    localStorage.removeItem('usuario');
    setUsuario(null);
    navigate('/');
  };

  const manejarLogin = async (email, password) => {
    const body = {
      email,
      password
    };

    try {
      const response = await fetch('/api/usuarios/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
      });

      const textoRespuesta = await response.text();

      if (!response.ok) {
        throw new Error(textoRespuesta || 'Login fallido');
      }

      const data = JSON.parse(textoRespuesta);

      if (!data.token) {
        throw new Error('El backend no devolvió token');
      }

      const usuarioLogueado = {
        id: data.id || data.usuario?.id,
        nombre: data.nombre || data.usuario?.nombre || email,
        apellido: data.apellido || data.usuario?.apellido || '',
        email: data.email || data.usuario?.email || email,
        rol: data.rol || data.usuario?.rol
      };

      localStorage.setItem('token', data.token);
      localStorage.setItem('email', usuarioLogueado.email);
      localStorage.setItem('usuario', JSON.stringify(usuarioLogueado));

      setUsuario(usuarioLogueado);
      setShowModal(false);

      alert('Login correcto');
    } catch (error) {
      console.error('ERROR COMPLETO LOGIN:', error);
      alert('Login fallido: ' + error.message);
    }
  };

  return (
    <>
      <div className="top-bar">
        🟢 SERVIDOR CLUB OFICIAL RP — ONLINE [24/7]
      </div>

      <header className="header">
        <div className="header-top">
          <div className="brand-container">
            <img
              src="/images/logo.png"
              alt="Club Oficial RP"
              className="brand-logo"
            />

            <div className="brand-text">
              <h1>CLUB OFICIAL RP</h1>
              <p>COMUNIDAD OFICIAL DE UNTURNED ROLEPLAY</p>
            </div>
          </div>

          <div className="header-actions">
            <a
              href="https://discord.gg/FP7qx9kpTw"
              target="_blank"
              rel="noopener noreferrer"
              className="discord-btn"
            >
              💬 DISCORD
            </a>

            <button className="connect-btn">
              ▶ CONECTAR
            </button>
          </div>
        </div>

        <div className="menu-bar">
          <Link to="/" className="menu-link">
            🏠 INICIO
          </Link>

          <Link to="/noticias" className="menu-link">
            📰 NOTICIAS
          </Link>

          <Link to="/" className="menu-link">
            🌐 SERVIDORES
          </Link>

          <Link to="/items" className="menu-link">
            🎒 ITEMS
          </Link>

          <Link to="/vehiculos" className="menu-link">
            🚘 VEHICULOS
          </Link>

          <Link to="/tienda" className="menu-link">
            🛒 TIENDA
          </Link>

          <Link to="/nosotros" className="menu-link">
            👥 NOSOTROS
          </Link>

          <a
            href="https://discord.gg/FP7qx9kpTw"
            target="_blank"
            rel="noopener noreferrer"
            className="menu-link"
          >
            💬 DISCORD
          </a>

          

          {/* SOLO MODERADORES */}
          {usuario?.rol === 'MODERADOR' && (
            <Link
              to="/moderador/crear-post"
              className="menu-link"
            >
              🛡 CREAR POSTS
            </Link>
          )}

          <div className="menu-user">
            {usuario ? (
              <>
                <span className="user">
                  👤 {usuario.nombre}
                </span>

                <button
                  className="btn-acceder"
                  onClick={cerrarSesion}
                >
                  Salir
                </button>
              </>
            ) : (
              <button
                className="btn-acceder"
                onClick={() => setShowModal(true)}
              >
                Login
              </button>
            )}
          </div>
        </div>
      </header>

      {showModal && (
        <LoginModal
          onClose={() => setShowModal(false)}
          onLogin={manejarLogin}
        />
      )}
    </>
  );
};

export default Header;